(function () {
  'use strict';

  /* ============================================================
     KODIAK SPORTS - GLOBAL RUBBER FLOORING CALCULATOR (DOM glue)
     Math lives in assets/kodiak-rubber-quote-engine.js
     (window.KodiakRubberQuote) — this file only reads inputs,
     calls the engine, and writes results to the DOM.

     Roll width: always 4ft (ROLLWIDTH-4)
     Order minimum: $500 (ORDERMIN-50000 tag = pennies)
     Min roll length: 15ft

     Agent/integration API:
       window.KodiakCalc.getQuote({price_per_sqft, roll_width_ft, order_min_usd})
       window.KodiakCalc.getState()
       document event 'kodiak:quote'  (detail = full quote payload)
       <script type="application/json" id="kodiak-quote-json"> (live JSON dump)
       <script type="application/json" id="kodiak-calc-data"> (static contract,
         Liquid-rendered in the section — readable without JS)

     Deep links (parsed on load, auto-calculates):
       ?length=20&width=15            Area 1 dimensions (decimal feet; also
                                      accepts 10'6, 10-6, 10 1/2 formats)
       &length2=..&width2=.. (..4)    additional areas
       &direction=length|width        roll direction override (direction2..4)
       &thickness=3-8 | 3/8 | 9mm     highlights + scrolls to matching rows
       &color=blue                    pre-selects matching variant color
       Native form field names (area1_room_length_ft=...) are accepted too,
       so a no-JS GET submit of the form round-trips into a working deep link.
       As the customer edits, the URL is kept shareable via replaceState.
  ============================================================ */

  /*!
 * KODIAK SPORTS LLC — PROPRIETARY SOFTWARE
 * Copyright 2026 Kodiak Sports, LLC. All rights reserved.
 *
 * This calculator, including its user interface design, logic, architecture,
 * and implementation, is the exclusive intellectual property of Kodiak Sports, LLC.
 *
 * UNAUTHORIZED COPYING, REPRODUCTION, MODIFICATION, DISTRIBUTION, OR USE
 * OF THIS CODE OR ITS DESIGN — IN WHOLE OR IN PART — IS STRICTLY PROHIBITED
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF KODIAK SPORTS, LLC.
 *
 * Violations will be pursued to the fullest extent of applicable intellectual
 * property, trade secret, and unfair competition laws, including but not limited
 * to claims for injunctive relief, actual damages, and attorney's fees.
 *
 * Kodiak Sports, LLC | Plano, TX | www.kodiaksports.com
 */

  var Engine = window.KodiakRubberQuote;
  if (!Engine) {
    console.error('KodiakCalc: quote engine (kodiak-rubber-quote-engine.js) not loaded.');
    return;
  }

  var DEFAULT_ROLL_WIDTH = Engine.DEFAULTS.roll_width_ft;   // 4
  var MIN_ROLL_LENGTH    = Engine.DEFAULTS.min_roll_length_ft; // 15

  var areas = {
    1: { length: 0, width: 0, direction: 'length', manualDir: false },
    2: { length: 0, width: 0, direction: 'length', manualDir: false },
    3: { length: 0, width: 0, direction: 'length', manualDir: false },
    4: { length: 0, width: 0, direction: 'length', manualDir: false }
  };

  /* ---------- engine input builders ---------- */

  function getAreasInput() {
    var list = [];
    for (var i = 1; i <= 4; i++) {
      var a = areas[i];
      list.push({
        area_number: i,
        room_length_ft: a.length,
        room_width_ft: a.width,
        roll_direction: a.manualDir ? a.direction : 'auto'
      });
    }
    return list;
  }

  function buildQuote(opts) {
    opts = opts || {};
    return Engine.computeRubberQuote({
      areas: getAreasInput(),
      roll_width_ft: opts.roll_width_ft || DEFAULT_ROLL_WIDTH,
      min_roll_length_ft: MIN_ROLL_LENGTH,
      max_roll_length_ft: opts.max_roll_length_ft || 0,
      price_per_sqft: opts.price_per_sqft,
      discount_tiers: window.kodiakDiscountTiers,
      order_min_usd: opts.order_min_usd
    });
  }

  /* ---------- DOM helpers ---------- */

  // Per-product maximum single-roll length (ft) from data-max-roll-length; 0 = no limit
  function rowMaxLength(row) {
    return parseInt(row.getAttribute('data-max-roll-length')) || 0;
  }

  // Set text content WITHOUT destroying child spans
  function setTextKeepSpans(el, text) {
    if (!el) return;
    var children = Array.prototype.slice.call(el.childNodes);
    children.forEach(function (node) {
      if (node.nodeType === 3) el.removeChild(node);
    });
    el.insertBefore(document.createTextNode(text), el.firstChild);
  }

  function setDirButtons(areaNum, dir) {
    document.querySelectorAll('.rc-dir-btn[data-area="' + areaNum + '"]').forEach(function (btn) {
      var active = btn.getAttribute('data-dir') === dir;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ---------- Step 1: area cards ---------- */

  function updateAreaCard(areaNum) {
    var a      = areas[areaNum];
    var sqftEl = document.querySelector('.rc-area-sqft[data-area="' + areaNum + '"]');
    var opt1El = document.querySelector('.rc-area-opt1[data-area="' + areaNum + '"]');
    var opt2El = document.querySelector('.rc-area-opt2[data-area="' + areaNum + '"]');
    var card   = document.querySelector('.rc-area-card[data-area="' + areaNum + '"]');
    var tag1   = document.querySelector('.rc-lowest-opt1[data-area="' + areaNum + '"]');
    var tag2   = document.querySelector('.rc-lowest-opt2[data-area="' + areaNum + '"]');

    if (a.length <= 0 || a.width <= 0) {
      a.sqft = 0;
      if (sqftEl) sqftEl.textContent = '—';
      setTextKeepSpans(opt1El, '—');
      setTextKeepSpans(opt2El, '—');
      if (tag1) tag1.style.display = 'none';
      if (tag2) tag2.style.display = 'none';
      return;
    }

    a.sqft = a.length * a.width;

    var opt1 = Engine.calcRollOption(a.length, a.width, DEFAULT_ROLL_WIDTH, 'length', MIN_ROLL_LENGTH);
    var opt2 = Engine.calcRollOption(a.length, a.width, DEFAULT_ROLL_WIDTH, 'width', MIN_ROLL_LENGTH);

    a.opt1 = opt1;
    a.opt2 = opt2;

    if (sqftEl) sqftEl.textContent = Math.round(a.sqft).toLocaleString() + ' sq ft';
    if (opt1) setTextKeepSpans(opt1El, opt1.display_note);
    if (opt2) setTextKeepSpans(opt2El, opt2.display_note);

    // Auto-select lowest sq ft only if customer hasn't manually chosen
    var bestDir = 'length';
    if (opt1 && opt2) {
      bestDir = (opt2.purchased_sqft < opt1.purchased_sqft) ? 'width' : 'length';
    }

    if (!areas[areaNum].manualDir) {
      areas[areaNum].direction = bestDir;
      if (card) card.setAttribute('data-selected', bestDir);
      setDirButtons(areaNum, bestDir);
    } else {
      bestDir = areas[areaNum].direction;
    }

    // Show ★ Lowest Price tag on best option
    var equalSqFt = (opt1 && opt2 && opt1.purchased_sqft === opt2.purchased_sqft);
    if (tag1) tag1.style.display = (bestDir === 'length' || equalSqFt) ? 'block' : 'none';
    if (tag2) tag2.style.display = (bestDir === 'width'  || equalSqFt) ? 'block' : 'none';
  }

  function recalcAreas() {
    for (var i = 1; i <= 4; i++) updateAreaCard(i);
    recalcProducts();
  }

  /* ---------- Step 2: product table ---------- */

  function activeAreaParts(quote) {
    var cartParts = [], displayParts = [];
    quote.areas.forEach(function (qa) {
      if (qa.room_sqft > 0 && qa.selected) {
        cartParts.push('Area ' + qa.area_number + ': ' + qa.selected.cart_note);
        displayParts.push('Area ' + qa.area_number + ': ' + qa.selected.display_note);
      }
    });
    return { cartNote: cartParts.join(' | '), displayParts: displayParts };
  }

  function recalcProducts() {
    var quoteCache = {}; // keyed by roll width + max roll length

    document.querySelectorAll('.rc-product-row').forEach(function (row) {
      var rollWidth = parseInt(row.getAttribute('data-roll-width')) || DEFAULT_ROLL_WIDTH;
      var maxLen    = rowMaxLength(row);
      var cacheKey  = rollWidth + ':' + maxLen;
      if (!quoteCache[cacheKey]) quoteCache[cacheKey] = buildQuote({ roll_width_ft: rollWidth, max_roll_length_ft: maxLen });
      var quote   = quoteCache[cacheKey];
      var rollsEl = row.querySelector('.rc-rolls-output');
      var totalEl = row.querySelector('.rc-total-display');
      var atcBtn  = row.querySelector('.rc-atc-btn');
      var selectEl = row.querySelector('.rc-variant-select');
      var priceEl  = row.querySelector('.rc-price-display');

      var price = 0;
      var selOpt = (selectEl && selectEl.selectedIndex >= 0) ? selectEl.options[selectEl.selectedIndex] : null;
      if (selOpt) {
        price = parseFloat(selOpt.getAttribute('data-price')) || 0;
      } else {
        price = parseFloat(row.getAttribute('data-first-price')) || 0;
      }
      if (priceEl) priceEl.textContent = price.toFixed(2);

      var totalSqFt = quote.totals.purchased_sqft;

      if (!totalSqFt || totalSqFt <= 0) {
        if (rollsEl) rollsEl.innerHTML = '—';
        if (totalEl) { totalEl.textContent = '—'; totalEl.classList.remove('has-value'); }
        if (atcBtn)  atcBtn.disabled = true;
        return;
      }

      var parts = activeAreaParts(quote);
      var totalPrice = totalSqFt * price;

      if (rollsEl) {
        rollsEl.innerHTML = parts.displayParts.map(function (p) {
          return '<div>' + p + '</div>';
        }).join('');
      }
      if (totalEl) {
        totalEl.textContent = '$' + totalPrice.toFixed(2);
        totalEl.setAttribute('title', 'Material subtotal before volume discount, freight and tax');
        totalEl.classList.add('has-value');
      }
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.setAttribute('data-sqft', totalSqFt);
        atcBtn.setAttribute('data-rolls-note', parts.cartNote);
        atcBtn.setAttribute('data-total-price', totalPrice.toFixed(2));
      }
    });

    if (window.kodiakHighlightTier) window.kodiakHighlightTier(0);

    publishQuote();
  }

  /* ---------- Agent/integration surface ---------- */

  function buildQuotePayload() {
    var geometry = buildQuote({});
    var products = [];
    document.querySelectorAll('.rc-product-row').forEach(function (row) {
      var selectEl = row.querySelector('.rc-variant-select');
      var price = 0, variantId = null, variantTitle = null;
      var opt = (selectEl && selectEl.selectedIndex >= 0) ? selectEl.options[selectEl.selectedIndex] : null;
      if (opt) {
        price = parseFloat(opt.getAttribute('data-price')) || 0;
        variantId = parseInt(opt.value) || null;
        variantTitle = (opt.textContent || '').trim();
      } else {
        price = parseFloat(row.getAttribute('data-first-price')) || 0;
      }
      var rollWidth = parseInt(row.getAttribute('data-roll-width')) || DEFAULT_ROLL_WIDTH;
      var orderMinUsd = (parseInt(row.getAttribute('data-ordermin')) || 50000) / 100;
      var maxLen = rowMaxLength(row);
      var q = buildQuote({ roll_width_ft: rollWidth, max_roll_length_ft: maxLen, price_per_sqft: price, order_min_usd: orderMinUsd });
      products.push({
        product_title: row.getAttribute('data-product-title') || null,
        product_url: row.getAttribute('data-product-url') || null,
        thickness: row.getAttribute('data-thickness') || null,
        variant_id: variantId,
        color: variantTitle,
        roll_width_ft: rollWidth,
        max_roll_length_ft: maxLen || null,
        purchased_sqft: q.totals.purchased_sqft,
        split_for_max_length: q.totals.split_for_max_length,
        roll_note: activeAreaParts(q).cartNote || null,
        pricing: q.pricing
      });
    });
    return {
      source: 'kodiak-rolled-rubber-calculator',
      seller: 'Kodiak Sports, LLC',
      totals_note: 'All prices are USD per square foot of purchased material. Totals are material only: freight and tax are excluded, and the volume discount is an estimate confirmed at checkout.',
      engine_version: Engine.VERSION,
      areas_input: getAreasInput(),
      quote: geometry,
      products: products
    };
  }

  function publishQuote() {
    var payload = buildQuotePayload();
    var holder = document.getElementById('kodiak-quote-json');
    if (holder) holder.textContent = JSON.stringify(payload);
    try {
      document.dispatchEvent(new CustomEvent('kodiak:quote', { detail: payload }));
    } catch (e) { /* older browsers */ }
    scheduleUrlSync();
    return payload;
  }

  window.KodiakCalc = {
    version: '2.2.0',
    engine: Engine,
    getState: getAreasInput,
    getQuote: function (opts) { return buildQuote(opts || {}); },
    getPayload: buildQuotePayload
  };

  /* ---------- Deep links (in) + shareable URL (out) ---------- */

  function fireEvent(el, type) {
    try {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    } catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent(type, true, true);
      el.dispatchEvent(ev);
    }
  }

  function getSearchParams() {
    if (typeof URLSearchParams === 'undefined') return null;
    try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
  }

  function normThickness(s) {
    return (s || '').toString().toLowerCase()
      .replace(/-/g, '/').replace(/["']/g, '').replace(/\s+/g, '');
  }

  function findThicknessRows(param) {
    var want = normThickness(param);
    if (!want) return [];
    return Array.prototype.filter.call(document.querySelectorAll('.rc-product-row'), function (row) {
      return normThickness(row.getAttribute('data-thickness')).indexOf(want) !== -1;
    });
  }

  var deeplinkReady = false;
  var syncTimer = null;

  function syncUrlNow() {
    if (!window.history || !history.replaceState) return;
    var qp = getSearchParams();
    if (!qp) return;
    // remove all dimension/direction params we own, then re-add from state
    for (var i = 1; i <= 4; i++) {
      var suf = (i === 1) ? '' : String(i);
      qp['delete']('length' + suf); qp['delete']('width' + suf); qp['delete']('direction' + suf);
      qp['delete']('length' + i); qp['delete']('width' + i); qp['delete']('direction' + i);
      qp['delete']('area' + i + '_room_length_ft');
      qp['delete']('area' + i + '_room_width_ft');
      qp['delete']('area' + i + '_roll_direction');
    }
    for (var j = 1; j <= 4; j++) {
      var a = areas[j];
      var s = (j === 1) ? '' : String(j);
      if (a.length > 0) qp.set('length' + s, String(Math.round(a.length * 100) / 100));
      if (a.width > 0) qp.set('width' + s, String(Math.round(a.width * 100) / 100));
      if (a.manualDir && (a.length > 0 || a.width > 0)) qp.set('direction' + s, a.direction);
    }
    var qs = qp.toString();
    try {
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) { /* ignore */ }
  }

  function scheduleUrlSync() {
    if (!deeplinkReady) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(syncUrlNow, 400);
  }

  function applyDeepLink() {
    var qp = getSearchParams();
    if (!qp) { deeplinkReady = true; return; }
    var applied = false;

    function setDim(cls, areaNum, raw) {
      var input = document.querySelector('.' + cls + '[data-area="' + areaNum + '"]');
      if (!input || raw === null || raw === '') return;
      input.value = raw;
      fireEvent(input, 'input');
      applied = true;
      if (areaNum > 1) {
        var card = document.querySelector('.rc-area-card[data-area="' + areaNum + '"]');
        if (card) card.classList.add('rc-mobile-visible');
      }
    }

    for (var i = 1; i <= 4; i++) {
      var suf = (i === 1) ? '' : String(i);
      var L = qp.get('length' + suf) || qp.get('length' + i) || qp.get('area' + i + '_room_length_ft');
      var W = qp.get('width' + suf) || qp.get('width' + i) || qp.get('area' + i + '_room_width_ft');
      var D = qp.get('direction' + suf) || qp.get('direction' + i) || qp.get('area' + i + '_roll_direction');
      setDim('rc-length', i, L);
      setDim('rc-width', i, W);
      if (D === 'length' || D === 'width') {
        var btn = document.querySelector('.rc-dir-btn[data-area="' + i + '"][data-dir="' + D + '"]');
        if (btn) { btn.click(); applied = true; }
      }
    }

    var rows = findThicknessRows(qp.get('thickness'));
    rows.forEach(function (row) { row.classList.add('rc-row-target'); });

    var colorParam = qp.get('color');
    if (colorParam) {
      var wantColor = colorParam.toLowerCase();
      var scope = rows.length ? rows : Array.prototype.slice.call(document.querySelectorAll('.rc-product-row'));
      scope.forEach(function (row) {
        var sel = row.querySelector('.rc-variant-select');
        if (!sel) return;
        for (var k = 0; k < sel.options.length; k++) {
          if ((sel.options[k].textContent || '').toLowerCase().indexOf(wantColor) !== -1) {
            if (sel.selectedIndex !== k) { sel.selectedIndex = k; fireEvent(sel, 'change'); }
            break;
          }
        }
      });
    }

    if (rows.length) {
      setTimeout(function () {
        try { rows[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { try { rows[0].scrollIntoView(); } catch (e2) { /* ignore */ } }
      }, 150);
    }

    deeplinkReady = true;
    if (applied) scheduleUrlSync(); // normalize legacy/form-style params
  }

  /* ---------- Order minimum popup + add to cart ---------- */

  function showOrderMinPopup(totalPrice, minDollars) {
    var overlay = document.getElementById('rc-popup-overlay');
    var msg     = document.getElementById('rc-popup-msg');
    if (msg) {
      msg.textContent = 'Our rubber flooring has a $' + minDollars.toFixed(0) +
        ' minimum order. Your current selection is $' + totalPrice.toFixed(2) +
        ', which is below this amount.';
    }
    if (overlay) overlay.classList.add('is-visible');
  }

  function addToCart(btn) {
    var row             = btn.closest('.rc-product-row');
    var selectEl        = row.querySelector('.rc-variant-select');
    var variantId       = selectEl ? parseInt(selectEl.value) : 0;
    var sqft            = parseInt(btn.getAttribute('data-sqft')) || 0;
    var rollsNote       = btn.getAttribute('data-rolls-note') || '';
    var totalPrice      = parseFloat(btn.getAttribute('data-total-price')) || 0;
    var orderMinTag     = parseInt(row.getAttribute('data-ordermin')) || 50000;
    var orderMinDollars = orderMinTag / 100;

    if (!variantId || sqft <= 0) return;

    if (totalPrice < orderMinDollars) {
      showOrderMinPopup(totalPrice, orderMinDollars);
      return;
    }

    btn.classList.add('loading');
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body   : JSON.stringify({
        id        : variantId,
        quantity  : sqft,
        properties: { 'Rolls': rollsNote }
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function () {
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.textContent = 'Added!';
      btn.disabled = false;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count, #CartCount, .header-cart-count, [data-cart-count]')
            .forEach(function (el) { el.textContent = cart.item_count; });
        });
      setTimeout(function () {
        btn.classList.remove('added');
        btn.textContent = 'Add to Cart';
      }, 3000);
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      btn.classList.remove('loading');
      btn.textContent = 'Error - Retry';
      btn.disabled = false;
    });
  }

  /* ---------- init ---------- */

  function init() {
    if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) { window.location.reload(); }

    // Semantic <form> wrapper: never navigate on Enter
    var calcForm = document.getElementById('kodiak-rubber-calc-form');
    if (calcForm) {
      calcForm.addEventListener('submit', function (e) { e.preventDefault(); recalcAreas(); });
    }

    document.querySelectorAll('.rc-length, .rc-width').forEach(function (input) {
      input.addEventListener('input', function () {
        var areaNum  = parseInt(this.getAttribute('data-area'));
        var isLength = this.classList.contains('rc-length');
        var val      = Engine.parseFeet(this.value);
        if (isLength) areas[areaNum].length = val;
        else          areas[areaNum].width  = val;
        recalcAreas();
      });
    });

    document.querySelectorAll('.rc-dir-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var areaNum = parseInt(this.getAttribute('data-area'));
        var dir     = this.getAttribute('data-dir');
        setDirButtons(areaNum, dir);
        areas[areaNum].direction = dir;
        areas[areaNum].manualDir = true;
        var card = document.querySelector('.rc-area-card[data-area="' + areaNum + '"]');
        if (card) card.setAttribute('data-selected', dir);
        recalcAreas();
      });
    });

    document.querySelectorAll('.rc-variant-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var selOpt = this.selectedIndex >= 0 ? this.options[this.selectedIndex] : null;
        var imgUrl = selOpt ? selOpt.getAttribute('data-img') : null;
        if (imgUrl && imgUrl !== 'null') {
          var img = this.closest('.rc-product-row').querySelector('.rc-thumb img');
          if (img) img.src = imgUrl;
        }
        recalcProducts();
      });
    });

    document.querySelectorAll('.rc-product-row').forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        var atcBtn = row.querySelector('.rc-atc-btn');
        if (!atcBtn) return;
        var total = parseFloat(atcBtn.getAttribute('data-total-price')) || 0;
        // Snippet's kodiakHighlightTier expects CENTS; calculator totals are DOLLARS.
        if (window.kodiakHighlightTier) window.kodiakHighlightTier(Math.round(total * 100));
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList.contains('rc-atc-btn')) {
        addToCart(e.target);
      }
    });

    var overlay  = document.getElementById('rc-popup-overlay');
    var closeBtn = document.getElementById('rc-popup-close');
    var dismiss  = document.getElementById('rc-popup-dismiss');
    function closePopup() { if (overlay) overlay.classList.remove('is-visible'); }
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (dismiss)  dismiss.addEventListener('click', closePopup);
    if (overlay)  overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    var observer = new MutationObserver(function () {
      document.querySelectorAll('.ajaxifyCart--num').forEach(function (input) {
        var el = input.parentElement;
        var container = null;
        for (var i = 0; i < 10; i++) {
          if (!el) break;
          if (el.textContent.indexOf('Rolls:') !== -1) { container = el; break; }
          el = el.parentElement;
        }
        if (!container) return;
        input.setAttribute('readonly', 'readonly');
        input.style.pointerEvents = 'none';
        input.style.opacity = '0.6';
        var qtyWrapper = input.closest('.ajaxifyCart--qty') || input.parentElement;
        var adjAdd   = qtyWrapper.querySelector('.ajaxifyCart--add');
        var adjMinus = qtyWrapper.querySelector('.ajaxifyCart--minus');
        if (adjAdd)   adjAdd.style.display   = 'none';
        if (adjMinus) adjMinus.style.display = 'none';
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // ── MOBILE: Banner dismiss ──
    var rcBanner = document.querySelector('.rc-mobile-banner');
    var rcBannerClose = document.querySelector('.rc-mobile-banner__close');
    if (rcBanner && rcBannerClose) {
      if (sessionStorage.getItem('rc-banner-dismissed')) rcBanner.classList.add('rc-hidden');
      rcBannerClose.addEventListener('click', function () {
        rcBanner.classList.add('rc-hidden');
        sessionStorage.setItem('rc-banner-dismissed', '1');
      });
    }
    // ── MOBILE: Add Another Area button ──
    var rcAddAreaBtn = document.querySelector('.rc-add-area-btn');
    if (rcAddAreaBtn) {
      var rcNextArea = 2;
      rcAddAreaBtn.addEventListener('click', function () {
        var card = document.querySelector('.rc-area-card[data-area="' + rcNextArea + '"]');
        if (card) { card.classList.add('rc-mobile-visible'); rcNextArea++; }
        if (rcNextArea > 4) rcAddAreaBtn.classList.add('rc-hidden');
      });
    }

    // ── DEEP LINKS: highlight style + apply URL params (must run LAST,
    //    after all listeners above are attached — it drives them via events) ──
    var rcHl = document.createElement('style');
    rcHl.textContent = '.rc-product-row.rc-row-target td{background:rgba(61,186,61,.14)!important;}' +
      '.rc-product-row.rc-row-target .rc-product-name{color:#2d9a2d;}';
    (document.head || document.body).appendChild(rcHl);
    applyDeepLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
